import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "src/app/shared/services/api.service";
import { IDataSourceBackendParam, ISampleTemplateInfo } from "../../domain/interfaces/samples.interface";

@Injectable({
  providedIn: "root",
})
export class SamplesService {
  constructor(private api: ApiService) {}

  /**
   * Converts backend parameters into query parameters by removing empty values.
   * @param params Raw parameters object
   * @return Cleaned object containing only defined query parameters
   */
  private toQueryParams(params: IDataSourceBackendParam): Record<string, string | number | boolean> {
    const cleaned: Record<string, string | number | boolean> = {};

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        cleaned[key] = value as string | number | boolean;
      }
    });

    return cleaned;
  }

  /**
   * Fetch the list of samples based on filters, pagination and sorting.
   * @param params Query parameters including filters, pagination and sorting options
   * @return List of sample objects
   */
  public getSamplesInfos(params: IDataSourceBackendParam): Observable<ISampleTemplateInfo[]> {
    return this.api.get("overview", this.toQueryParams(params)) as Observable<ISampleTemplateInfo[]>;
  }

  /**
   * Fetch the total count of samples matching given filters, pagination and sorting.
   * @param params Query parameters including filters, pagination and sorting options
   * @return Total number of matching samples
   */
  public getSamplesInfosCount(params: IDataSourceBackendParam): Observable<number> {
    return this.api.get("overview-count", this.toQueryParams(params)) as Observable<number>;
  }
}
